import { render, staticRenderFns } from "./MobileContactDialog.vue?vue&type=template&id=80a48378&scoped=true&"
import script from "./MobileContactDialog.vue?vue&type=script&lang=js&"
export * from "./MobileContactDialog.vue?vue&type=script&lang=js&"
import style0 from "./MobileContactDialog.vue?vue&type=style&index=0&id=80a48378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a48378",
  null
  
)

export default component.exports